import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { BondDetailWidget } from "@/widgets/bond/detail";

export const BondDetailPage = () => {
  useEffect(() => {
    document.title = "Бонд дэлгэрэнгүй";
  }, []);
  const { _id } = useParams<{ _id: string }>();
  return (
    <div className="page">
      <BondDetailWidget _id={_id} />
    </div>
  );
};
